export default function createBrowserTabChecker() {
  let receivedCloseRequest = false;

  async function handleCloseRequest() {
    if (receivedCloseRequest) return;
    else receivedCloseRequest = true;
    window.appAlreadyOpen = true;
  }

  function triggerEvent(event) {
    window.localStorage.setItem(event, "true");
    window.localStorage.removeItem(event);
  }

  function check() {
    window.addEventListener("storage", async ({ key }) => {
      if (key === "tabOpened") triggerEvent("closeTabRequest");
      if (key === "closeTabRequest") handleCloseRequest();
    });

    triggerEvent("tabOpened");
  }

  return {
    check
  };
}
